import { useFeatureFlag } from 'src/lib/featureFlagsOptimizley';

export function useReservationsFeatureToggle(): [boolean, boolean] {
  const [featureEnabled, loaded] = useFeatureFlag(
    'supplier-extranet-reservations',
  );

  return [loaded && featureEnabled, !loaded];
}
